<button
  class="text-to-speech-btn"
  (click)="toggleTextToSpeech()"
  [class.reading]="isReading"
  [class.paused]="isPaused"
  [attr.aria-label]="isReading ? (isPaused ? 'Resume reading' : 'Pause reading') : 'Start reading'"
  title="{{ isReading ? (isPaused ? 'Resume reading' : 'Pause reading') : 'Start reading' }}"
>
  <i class="fa" [ngClass]="{
    'fa-volume-up': isReading && !isPaused,
    'fa-pause': isReading && isPaused,
    'fa-volume-off': !isReading
  }"></i>
</button>
